import styled from "styled-components";

import Card from "../Card/Card";
import Box from "../Box/Box";
import Typography from "../Typography/Typography";
import Icon, { IconWeight } from "../Icon/Icon";
import { LayoutProps, SpaceProps, space } from "styled-system";

const StyledCard = styled(Card)<SpaceProps>`
  ${space}
`;

interface CardContent {
  headline: string;
  description: string;
  icon?: {
    name: string;
    weight: IconWeight;
    color?: string;
  };
  width?: LayoutProps["width"];
  height?: LayoutProps["height"];
  isWide?: boolean;
}

const CardWithIcon = ({
  headline,
  description,
  icon,
  height = "100%",
  isWide = false,
  width = { _: 300, tablet: isWide ? 460 : 300 },
}: CardContent) => (
  <StyledCard
    width={width}
    height={height}
    aria-label="wide card with icon"
    p={6}
    m={0}
    variant="hoverable"
  >
    <Box
      display="flex"
      width="100%"
      flexDirection={{ _: "column", tablet: isWide ? "row" : "column" }}
      alignItems={{ _: "center", tablet: "flex-start" }}
    >
      {icon && (
        <Icon
          name={icon.name}
          weight={icon.weight}
          color={icon.color}
          width={{
            _: isWide ? "38px" : "24px",
            tablet: isWide ? "52px" : "24px",
          }}
          height={{
            _: isWide ? "38px" : "24px",
            tablet: isWide ? "52px" : "24px",
          }}
          mb={{ _: 6, tablet: isWide ? 0 : 4 }}
          css={`
            flex-shrink: 0;
          `}
        ></Icon>
      )}
      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        alignItems={{ _: "center", tablet: "flex-start" }}
        pl={{ _: 0, tablet: isWide ? 6 : 0 }}
        overflow="hidden"
      >
        <Typography
          variant="h5"
          textAlign={{ _: "center", tablet: "left" }}
          color="text-color"
          m={0}
          css={`
            line-height: normal;
          `}
        >
          {headline}
        </Typography>
        <Typography
          variant="body"
          color="lighter-text-color"
          textAlign={{ _: "center", tablet: "left" }}
          mt={2}
          mb={0}
          mx={0}
          css={`
            line-height: 1.36;
            min-height: 57px;
          `}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  </StyledCard>
);

export default CardWithIcon;
